import React from 'react';
import SaveBar from '../../SaveBar/SaveBar';
import { fixedInfoTextStyle, requiredPanelStyle } from '../CampaignBrief/CampaignBriefStyles';

const CampaignBurstSavePanel = ({ campaignBurst, validationResults, createCampaignBurst, updateCampaignBurst }) => {
    const isBurstValid = campaignBurst?.budget && campaignBurst?.name && validationResults.budget &&
        validationResults.startDate &&
        validationResults.endDate &&
        validationResults.campaignId &&
        !validationResults.name?.status?.statusMessage;

    return (
        <div style={requiredPanelStyle}>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '90%'
                    }}
                >
                    <div id={'campaignBurst-referenceId'} style={{ paddingRight: 59 }}>
                        <span style={fixedInfoTextStyle}>
                            {window.translate('Campaign Burst Reference ID')}
                            {': '}
                            {campaignBurst?.id === window.emptyGuid ? 'XXXXXXXXXX' : campaignBurst?.referenceNumber}
                        </span>
                    </div>
                    <div id={'campaignBurst-externalReferenceId'} style={{ paddingRight: 57 }}>
                        <span style={fixedInfoTextStyle}>
                            {window.translate('External Reference ID')}
                            {': '}
                            {campaignBurst?.id === window.emptyGuid ? 'XXXXXXXXXX' : campaignBurst?.externalSourceRef}
                        </span>
                    </div>
                </div>
                <div style={{ display: 'flex', width: '10%' }}>
                    <SaveBar
                        campaign={campaignBurst}
                        handleCreate={createCampaignBurst}
                        handleUpdate={updateCampaignBurst}
                        isSticky={false}
                        readOnly={!isBurstValid}
                    />
                </div>
            </div>
        </div>
    );
};

export default CampaignBurstSavePanel;
